import { Container, Title, Divider, Transition, Group, Button, Center, SegmentedControl } from "@mantine/core";
import ResultsTable from "./parts/results.table.tsx";
import AccountPanel from "./parts/account.view.tsx";
import MainCard from "./parts/main.card";
import TeamPanel from "./parts/team.view.tsx";
import { useEffect, useState } from "react";
import { useResults } from "$/contexts/results.ctx.tsx";
import PersonalityReport from "$/panels/personality.report.tsx";
import { useProfile } from "$/contexts/profile.ctx.tsx";
import { useAuth } from '@/contexts/auth.ctx.tsx';
import { IconArrowLeft } from "@tabler/icons-react";
import ManagerView from "./parts/manager.view.tsx";

const data = [
    { label: 'Main', value: 'main' },
    { label: 'Account', value: 'account' },
    { label: 'Results', value: 'results' },
    { label: 'Team', value: 'team' },
    { label: 'Org', value: 'org' },
];

export default function Dashboard() {
    const [viewState, setViewState] = useState<'main' | 'account' | 'results' | 'team' | 'org'>('main');
    const { authLevel, accessorCan } = useAuth();
    const { selectedResult, selectResult } = useResults();
    const { selectedProfile } = useProfile();

    useEffect(() => {
        if (selectedResult) {
            setViewState('results');
        }
    }, [selectedResult]);

    const viewSegements = () => {
        return (
            <SegmentedControl 
                fullWidth
                color='yenta-blue'
                data={data.filter(d => {
                    switch (d.value){
                        case 'team':
                            return accessorCan('join-team');
                        case 'org':
                            return authLevel === 'MANAGER';
                        case 'results':
                            return false;
                        default:
                            return true;
                    }
                })} 
                value={viewState} 
                onChange={(value) => setViewState(value as typeof viewState)} 
                size="md"
            />
        )
    }

    return (
        <Container fluid >
            <Center mb={'md'} w={'100%'}>{viewSegements()}</Center>

            <Transition mounted={viewState === 'main'} transition="slide-right" duration={400}>
                {styles => (<div style={styles}>
                    {viewState === 'main' && <MainCard />}
                    <Divider my={'lg'} />
                    {viewState === 'main' && <ResultsTable />}
                </div>)}
            </Transition>
            <Transition mounted={viewState === 'account'} transition="slide-left" duration={400}>
                {styles => (<Group style={styles} wrap="nowrap">
                    <AccountPanel panelChangeReq={mode => setViewState(mode as typeof viewState)} />
                </Group>)}
            </Transition>
            <Transition mounted={viewState === 'results'} transition="slide-left" duration={400}>
                {styles => (<Group style={styles} wrap="nowrap">
                    <Button
                        onClick={() => {
                            setViewState('main');
                            selectResult(null);
                        }} 
                        variant="outline" 
                        size="xs"
                    ><IconArrowLeft /></Button>
                    <PersonalityReport
                        clientName={selectedResult?.testeeName || ''}
                        clientType={selectedResult?.result || ''}
                        agentType={selectedProfile?.testResult || ''}
                        testID={selectedResult?.id || ''}
                    />
                </Group>)}
            </Transition>
            <Transition mounted={viewState === 'team'} transition="slide-left" duration={400}>
                {styles => (<Group style={styles} wrap="nowrap">
                    <TeamPanel panelChangeReq={mode => setViewState(mode as typeof viewState)} />
                </Group>)}
            </Transition>
            <Transition mounted={viewState === 'org'} transition="slide-left" duration={400}>
                {styles => (<Group style={styles} wrap="nowrap">
                    <ManagerView />
                </Group>)}
            </Transition>

        </Container>
    )
}